import { Button, ButtonGroup, Intent, Position, Size, Tooltip } from "@blueprintjs/core" 
import { __, getID } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILandingSection, ITableRCell, ITableRow, LANDING_TYPE_CONTENT, TableContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"
import updateSection from "../utils/updateSection"

/* Protopia Ecosystem component */
export interface ITableThreadCellEditorProps {
    rowOrder: number
    th: ITableRCell
    section: ILandingSection
    primitive: TableContent
    children: any
}
const TableThreadCellEditor = (props: ITableThreadCellEditorProps): JSX.Element => {
    const isEdit : boolean = useLandingConsoleStore((state: ILandingConsoleStore) => state.isEdit )
    const onAdd = () => {
        const prevData: ILandingSection = JSON.parse( JSON.stringify(props.section) )
        const data: ILandingSection = {
            ...props.section,
            data: props.section.data.map(meat => {
                if(meat.type === LANDING_TYPE_CONTENT.TABLE && meat.id === props.primitive.id ) {
                    props.primitive.threads.cells.splice(
                        props.rowOrder + 1, 
                        0, 
                        {
                            id: getID('row'),
                            text: ""
                        }
                    )
                    return {
                        ...props.primitive,
                        threads: {
                            ...props.primitive.threads,
                            cells: props.primitive.threads.cells 
                        },
                        data: props.primitive.data.map(( column: ITableRow ) => {
                            column.cells.splice(
                                props.rowOrder + 1, 
                                0, 
                                {
                                    id: getID('cell'),
                                    text: ""
                                }
                            )
                            return column
                        })
                    }
                }
                return meat
            })
        }
        const historyStep: IHistoryStep = {
            data,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title: "Add table row" 
        }
        updateSection( data, historyStep )
    }
    const onRemove = () => {
        const prevData: ILandingSection = JSON.parse( JSON.stringify(props.section) )
        const data: ILandingSection = {
            ...props.section,
            data: props.section.data.map(meat => {
                if(meat.type === LANDING_TYPE_CONTENT.TABLE && meat.id === props.primitive.id ) {
                    props.primitive.threads.cells.splice(
                        props.rowOrder, 
                        1
                    )
                    return {
                        ...props.primitive,
                        threads: {
                            ...props.primitive.threads,
                            cells: props.primitive.threads.cells 
                        },
                        data: props.primitive.data.map(( column: ITableRow ) => {
                            column.cells.splice(
                                props.rowOrder, 
                                1
                            )
                            return column
                        })
                    }
                }
                return meat
            })
        }
        const historyStep: IHistoryStep = {
            data,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title: "Remove table row" 
        }
        updateSection( data, historyStep )
    }
    return  <>
        {props.children}
        { 
            isEdit && <div className="landing-table-row-editor pe-surface pe-item-editor z-index-100" data-select-type="ignore" >
                <ButtonGroup>
                    { 
                        props.rowOrder < props.primitive.threads.cells.length - 1
                            ?
                            <Tooltip
                                intent={Intent.PRIMARY}
                                compact
                                position={Position.TOP_LEFT}
                                content={<div className="">{__("Swap row right")}</div>}
                            >
                                <Button
                                    className="edit-menu-btn"
                                    icon="chevron-right"
                                    size={ Size.SMALL }
                                />
                            </Tooltip>
                            :
                            <></>
                    }
                    {
                        props.rowOrder > 0
                            ?
                            <Tooltip
                                intent={Intent.PRIMARY}
                                compact
                                position={Position.TOP_LEFT}
                                content={<div className="">{__("Swap row left")}</div>}
                            >
                                <Button
                                    className="edit-menu-btn"
                                    icon="chevron-left"
                                    size={ Size.SMALL }
                                />
                            </Tooltip>
                            :
                            <></>
                    } 
                    <Tooltip
                        intent={Intent.PRIMARY}
                        compact
                        position={Position.TOP_LEFT}
                        content={<div className="">{__("Edit")}</div>}
                    >
                        <Button
                            className="edit-menu-btn"
                            icon={ "edit" }
                            size={ Size.SMALL } 
                        />
                    </Tooltip>
                    <Tooltip
                        intent={Intent.PRIMARY}
                        compact
                        position={Position.TOP_LEFT}
                        content={<div className="">{__("Add row after")}</div>}
                    >
                        <Button
                            className="edit-menu-btn"
                            icon={ "plus" }
                            size={ Size.SMALL }
                            onClick={ onAdd }
                        />
                    </Tooltip>
                    <Tooltip
                        intent={Intent.PRIMARY}
                        compact
                        position={Position.TOP_LEFT}
                        content={<div className="">{__("Remove row")}</div>}
                    >
                        <Button
                            className="edit-menu-btn"
                            icon={ "trash" }
                            size={ Size.SMALL }
                            onClick={ onRemove }
                        />
                    </Tooltip>
                </ButtonGroup>
            </div>
        }
    </> 
}
export default TableThreadCellEditor